<template>
    <div class="h-100">
        <b-container class="p-0" fluid>
            <b-row align-h="center">
                <b-col cols="12" md="10">
                    <b-link :to="{ name: 'contacts-lists' }">
                        <font-awesome-icon icon="arrow-left" />
                        {{ $t("Back") }}
                    </b-link>

                    <h1 class="mt-1">
                        {{ $t("contacts.lists.contacts-lists") }} / {{ $t("Edit") }} "{{
                            contactsList ? contactsList.name : ""
                        }}"
                    </h1>

                    <hr />
                    <template>
                        <contact-lists-form
                            v-if="
                                contactsList &&
                                originalContactListContacts &&
                                contactsList.id === Number($route.params.id)
                            "
                            :current-contact-list-id="contactsList.id"
                            :original-contact-list-contacts="originalContactListContacts"
                            edit-mode
                            @canceled="backToOverview"
                            @finished="backToOverview"
                        />
                        <b-spinner v-else />
                    </template>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { BCol, BContainer, BLink, BRow, BSpinner } from "bootstrap-vue";
import ContactListsForm from "@/views/components/contact-lists/contactListsForm";
import useContactsLists from "@/composables/useContactsLists";
import router from "@/router";
import { cloneDeep } from "lodash";
import { ref, watch } from "@vue/composition-api";

export default {
    components: {
        BContainer,
        BCol,
        BRow,
        BLink,
        BSpinner,
        ContactListsForm,
    },
    methods: { cloneDeep },
    setup(props, context) {
        const bvModal = context.root.$bvModal;

        const { fetchContactsList, contactsList } = useContactsLists(bvModal);
        const originalContactListContacts = ref(null);

        fetchContactsList(router.currentRoute.params.id);

        // we use this to get the original contacts  of the contact list
        let isInitialWatchTriggered = false;
        watch(
            contactsList,
            (newVal) => {
                if (!isInitialWatchTriggered && newVal.contacts) {
                    originalContactListContacts.value = cloneDeep(newVal.contacts);
                    isInitialWatchTriggered = true;
                }
            },
            { immediate: true, deep: true }
        );

        const backToOverview = () => {
            router.push({ name: "contacts-lists" });
        };

        return {
            contactsList,
            originalContactListContacts,
            backToOverview,
        };
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
